module.exports = __webpack_public_path__ + "assets/img/HR-Connect-Website-w720.4e4db291.webp";